module.exports = __webpack_public_path__ + "static/media/fantasy_sports.da3eac18.svg";